import { gql } from "@apollo/client";

export const FETCH_USER_PROFILE = gql`
    query UserProfile {
        userProfile {
            id
            name
            title
            email
            emailVerified
            role
            chatSettings {
                language
                verbosity
                responseLength
                responseStyle
                showAmendments
                showOriginals
                showSummaries
                advancedSettingsEnabled
            }

            usedPages
            pageQuota
        }
    }
`;